
 const Box = [
    {
        id:0,
        color: "red"
    },

    {
        id:1,
        color: "yellow"
       
    },

    {
        id:2,
        color: "green"
       
    }
]

export default Box